import nodeClient from "./node-client";

export const getUserById = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/get/user?${encodeURI(query)}`
  );
  return response.data.result;
};

export const isUserIdAvailable = async (query) => {
  const response = await nodeClient.get(
    `service/private/v0/user/exist?${encodeURI(query)}`
  );
  return response.data.result;
};

export const getUserLogs = async (query) => {
  const response = await nodeClient.get(
    `service/private/v0/get/user/log?${encodeURI(query)}`
  );
  return response.data.result;
};

export const saveUser = async (formData) => {
  const response = await nodeClient.post(
    `/service/private/v0/add/user`,
    formData
  );
  return response?.data?.result;
};

export const fetchUsersByAlias = async (query = "") => {
  const response = await nodeClient.get(
    `/service/public/v0/users/find/by/alias?${encodeURI(query)}`
  );
  return response?.data;
};

export const changeAdminPassword = async (payload = {}) => {
  const response = await nodeClient.post(
    `/service/private/v0/admin/change/password`,
    payload
  );
  return response?.data;
};

export const fetchAdminUsers = async () => {
  const response = await nodeClient.get(`/service/private/v0/get/admin/users`);
  return response?.data;
};

export const saveCACUser = async (formData) => {
  const response = await nodeClient.post(
    `/service/private/v0/admin/add/user`,
    formData
  );
  return response?.data?.result;
};